import React from "react";
import itsmeLogoSquare from "../../assets/images/png/itsmeLogoSquare.png";

export default class ItsmeLogoSquare extends React.Component {
    render(): React.ReactElement {
        return <img src={itsmeLogoSquare} alt="itsme logo square" />;
    }
}
